document.addEventListener("DOMContentLoaded", initTeamSliders);

function initTeamSliders() {
    const sliders = document.querySelectorAll(".team-slider");

    sliders.forEach((slider) => {
        const section = slider.closest(".team-slider-container");

        jQuery(slider).slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            arrows: true,
            prevArrow: section.querySelector(".team-slider-prev"),
            nextArrow: section.querySelector(".team-slider-next"),
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });

    jQuery(".team-slider, .team-card-grid").on(
        "click",
        ".read-bio, .close-bio",
        function () {
            const card = this.closest(".card");
            const overlay = card.querySelector(".overlay");
            jQuery(overlay).fadeToggle("slow");
        },
    );
}
